// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-2uOLV","price":"price-J2y0d","footer":"footer-1sXKO"};